var map = {
	"./authen/authen.module": [
		"./src/app/authen/authen.module.ts",
		"common",
		"authen.module"
	],
	"./consignment/consignment.module": [
		"./src/app/consignment/consignment.module.ts",
		"common",
		"consignment.module"
	],
	"./pages/component/alert/alert.module": [
		"./src/app/pages/component/alert/alert.module.ts",
		"alert.module"
	],
	"./pages/component/carousel/carousel.module": [
		"./src/app/pages/component/carousel/carousel.module.ts",
		"carousel.module"
	],
	"./pages/component/datepicker/datepicker.module": [
		"./src/app/pages/component/datepicker/datepicker.module.ts",
		"datepicker.module"
	],
	"./pages/component/dropdown-collapse/dropdown-collapse.module": [
		"./src/app/pages/component/dropdown-collapse/dropdown-collapse.module.ts",
		"dropdown-collapse.module"
	],
	"./pages/component/modal/modal.module": [
		"./src/app/pages/component/modal/modal.module.ts",
		"modal.module"
	],
	"./pages/component/pagination/pagination.module": [
		"./src/app/pages/component/pagination/pagination.module.ts",
		"pagination.module"
	],
	"./pages/component/popover-tooltip/popover-tooltip.module": [
		"./src/app/pages/component/popover-tooltip/popover-tooltip.module.ts",
		"popover-tooltip.module"
	],
	"./pages/component/progressbar/progressbar.module": [
		"./src/app/pages/component/progressbar/progressbar.module.ts",
		"progressbar.module"
	],
	"./pages/component/rating/rating.module": [
		"./src/app/pages/component/rating/rating.module.ts",
		"rating.module"
	],
	"./pages/component/tabs/tabs.module": [
		"./src/app/pages/component/tabs/tabs.module.ts",
		"tabs.module"
	],
	"./pages/component/timepicker/timepicker.module": [
		"./src/app/pages/component/timepicker/timepicker.module.ts",
		"timepicker.module"
	],
	"./pages/component/typehead/typehead.module": [
		"./src/app/pages/component/typehead/typehead.module.ts",
		"typehead.module"
	],
	"./pages/icons/fontawesome/fontawesome.module": [
		"./src/app/pages/icons/fontawesome/fontawesome.module.ts",
		"common",
		"fontawesome.module"
	],
	"./pages/icons/material/material.module": [
		"./src/app/pages/icons/material/material.module.ts",
		"common",
		"material.module"
	],
	"./pages/icons/simpleline/simpleline.module": [
		"./src/app/pages/icons/simpleline/simpleline.module.ts",
		"common",
		"simpleline.module"
	],
	"./payment/payment.module": [
		"./src/app/payment/payment.module.ts",
		"common",
		"payment.module"
	],
	"./purchase/purchase-product/purchase-product.module": [
		"./src/app/purchase/purchase-product/purchase-product.module.ts",
		"common",
		"purchase-product.module"
	],
	"./purchase/purchase.module": [
		"./src/app/purchase/purchase.module.ts",
		"common",
		"purchase.module"
	],
	"./receipt/receipt.module": [
		"./src/app/receipt/receipt.module.ts",
		"common",
		"receipt.module"
	],
	"./refund/refund.module": [
		"./src/app/refund/refund.module.ts",
		"common",
		"refund.module"
	],
	"./stock/stock-check/stock-check.module": [
		"./src/app/stock/stock-check/stock-check.module.ts",
		"common",
		"stock-check.module"
	],
	"./stock/stock-transfer/stock-transfer.module": [
		"./src/app/stock/stock-transfer/stock-transfer.module.ts",
		"common",
		"stock-transfer.module"
	],
	"./user/user.module": [
		"./src/app/user/user.module.ts",
		"common",
		"user.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main